module.exports = __webpack_public_path__ + "dece5a55f1005978e8c0613efcdaea43.png";